import { Paths } from './app.paths';
import * as React from 'react';
import { LayoutAuth } from './pages/layout/layout-auth';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { LayoutSlim } from './pages/layout/layout-slim';
import { isMobile } from './services/utils';
import { LayoutWorkspace } from './pages/layout/layout-workspace';

export interface Route {
    path: string;
    element?: React.ReactNode;
    layout?: React.FC;
}

export const router = createBrowserRouter([
    {
        path: '/',
        element: <LayoutAuth />,
        children: [
            {
                path: Paths.Login,
                lazy: () => import('./pages/auth/login'),
            },
            {
                path: Paths.RegisterEuroplan,
                lazy: () => import('./pages/auth/register-europlan'),
            },
            {
                path: Paths.Activate,
                lazy: () => import('./pages/auth/activate'),
            },
            {
                path: Paths.SetPassword,
                lazy: () => import('./pages/auth/set-password'),
            },
            {
                path: Paths.ResetPassword,
                lazy: () => import('./pages/auth/reset-password'),
            },
        ],
    }, {
        path: '/',
        element: <LayoutWorkspace />,
        children: [
            {
                path: Paths.Workspace + '/:workspaceId?/:itemId?',
                lazy: () => import('./pages/workspace/workspace'),
            }, {
                path: Paths.Items,
                lazy: () => import('./pages/workItem/workItems'),
            }, {
                path: Paths.Items + '/:id',
                lazy: () => import('./pages/workItem/workItem'),
            }, {
                path: Paths.Record,
                lazy: () => import('./pages/record/record'),
            },
        ],
    }, {
        path: '/',
        element: <LayoutSlim />,
        children: [
            {
                path: Paths.Extension,
                lazy: () => import('./pages/extension/extension'),
            },
            {
                path: Paths.GenerateApiToken,
                lazy: () => import('./pages/extension/generate-api-token'),
            },
        ],
    }, {
        path: Paths.Settings,
        lazy: () => import('./pages/settings/settings-layout'),
        children: [
            {
                path: Paths.Settings_Users,
                lazy: () => import('./pages/settings/users/users'),
            },
        ],
    },
    { index: true, element: <Navigate replace to={isMobile ? Paths.Record : Paths.Workspace} /> },
    { path: '*', element: <Navigate replace to={isMobile ? Paths.Record : Paths.Workspace} /> },
], { basename: '/' });
